export default __webpack_public_path__ + "static/media/downarrow.83f8e580.svg";